import { boolean, number, shape, string } from 'prop-types'

export const buyTogetherProductDataType = {
  id: string.isRequired,
  name: string.isRequired,
  canonicalURL: string.isRequired,
  thumbnailURL: string.isRequired,
  discount: number.isRequired,
  redPoints: number.isRequired,
  redPointsIsActive: boolean,
  multiplierRP: number.isRequired,
  redPointsMultiplierIsValid: boolean,
  pharmaObl: boolean,
}

export const buyTogetherProductDataShapeType = shape(buyTogetherProductDataType)
